import { Box, Tooltip } from "@mui/material";
import { ReactNode } from "react";

interface PopoverListProps<T,> {
    list: T[];
    label: string;
    render: (item: T) => ReactNode;
    limit?: number;
    underline?: boolean;
}

const PopoverList = <T extends { id: number | string },>({
	list,
	render,
	label,
	limit = 1,
	underline,
}: PopoverListProps<T>) => {
	if (!list || list.length === 0) {
		return null;
	}

	const popoverContent = (
		<div>
			{list.map((item) => (
				<div key={item.id}>{render(item)}</div>
			))}
		</div>
	);

	if (list.length <= limit) {
		return popoverContent;
	}

	return (
		<Tooltip
			title={(
				<Box px={2} py={1} sx={{ fontSize: 13 }}>
					{popoverContent}
				</Box>
			)}
			enterDelay={150}
			leaveDelay={200}
			slotProps={{
				tooltip: {
					sx: {
						bgcolor: "background.paper",
						color: "text.primary",
						boxShadow: 3,
						p: 0,
					},
				},
			}}
		>
			<span
				style={{
					textDecoration: underline ? "underline" : "none",
					cursor: "pointer",
				}}
			>
				{`${list.length} ${label}`}
			</span>
		</Tooltip>
	);
};

export default PopoverList;
